module.exports = __webpack_public_path__ + "img/RevenueIcon.9d453d0f.svg";